// packages
import { feature, mesh } from 'topojson-client';

// types
import type { Topology } from 'topojson-specification';

export default function topojsonToGeoJson(topology: Topology, keys: string[]) {
  const geojson = [];

  for (let idx = 0; idx < keys.length; idx++) {
    const key = keys[idx];
    const objects = topology.objects[key];

    const obj = {};

    obj['bounds'] = feature(topology, objects);
    obj['borders'] = mesh(topology, objects, (a, b) => a !== b);

    geojson.push(obj);
  }

  return geojson;
}

export function getGeoJsonFromTopoJson<T extends Topology>(
  topology: T,
  key: string,
  innerlines = false,
  outerlines = false
) {
  const object = topology.objects[key];

  return {
    collection: feature(topology, object),
    innerlines: innerlines
      ? mesh(topology, object, (a, b) => a !== b)
      : undefined,
    outerlines: outerlines
      ? mesh(topology, object, (a, b) => a === b)
      : undefined,
  };
}
